module.exports = __webpack_public_path__ + "img/zs3.81ef2f7d.jpg";